"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopyTooltip = void 0;
var clipboard_copy_1 = __importDefault(require("clipboard-copy"));
var react_1 = require("react");
var miscHooks_1 = require("../../../hooks/miscHooks");
var CopyTooltip_style_1 = __importDefault(require("./CopyTooltip.style"));
function useCopyTooltip(_a) {
    var textToCopy = _a.textToCopy, leaveDelay = _a.leaveDelay;
    var _b = __read((0, react_1.useState)({ isOpen: false, hasCopied: false }), 2), state = _b[0], setState = _b[1];
    var getIsMounted = (0, miscHooks_1.useMountedState)();
    var handleClick = (0, react_1.useCallback)(function () {
        void (0, clipboard_copy_1.default)(textToCopy);
        setState({ isOpen: true, hasCopied: true });
    }, [textToCopy]);
    var handleClose = (0, react_1.useCallback)(function () {
        setState(function (prevState) { return (__assign(__assign({}, prevState), { isOpen: false })); });
        setTimeout(function () { return getIsMounted() && setState(function (prevState) { return (__assign(__assign({}, prevState), { hasCopied: false })); }); }, leaveDelay);
    }, [leaveDelay, getIsMounted]);
    var handleOpen = (0, react_1.useCallback)(function () { return setState(function (prevState) { return (__assign(__assign({}, prevState), { isOpen: true })); }); }, []);
    return __assign(__assign({}, state), { classes: (0, CopyTooltip_style_1.default)(), handleClick: handleClick, handleClose: handleClose, handleOpen: handleOpen, leaveDelay: leaveDelay });
}
exports.useCopyTooltip = useCopyTooltip;
